import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import PageSeo from "@/components/PageSeo";
import Hero from "@/components/sections/Hero";
import TrustedBy from "@/components/sections/TrustedBy";
import SelectedWork from "@/components/sections/SelectedWork";
import Divisions from "@/components/sections/Divisions";
import WhatWeSolve from "@/components/sections/WhatWeSolve";
import Services from "@/components/sections/Services";
import Proof from "@/components/sections/Proof";
import Legacy from "@/components/sections/Legacy";
import Insights from "@/components/sections/Insights";

export default function Home() {
  const [featured, setFeatured] = useState([]);
  const [allProjects, setAllProjects] = useState([]);

  useEffect(() => {
    api.get("/projects?featured=true").then((r) => setFeatured(r.data || [])).catch(() => {});
    api.get("/projects").then((r) => setAllProjects(r.data || [])).catch(() => {});
  }, []);

  return (
    <main className="bg-ink text-bone">
      <PageSeo
        title="Relatable Studio · Premium Production House & Brand Storytelling · Bangalore, India"
        description="Relatable Studio is a Bangalore-based creative production house. We build brand films, ad campaigns, founder stories, employer branding films and corporate videos for India's most demanding brands. 1600+ projects · 300+ clients."
        path="/"
      />
      <Hero projects={allProjects} />
      <TrustedBy />
      <SelectedWork projects={featured} />
      <Divisions />
      <WhatWeSolve />
      <Services />
      <Proof />
      <Legacy />
      <Insights />
    </main>
  );
}
